/* global modForm modUtils */
export const initPhoneAssignmentConfig = function(ignoreCTParamToShowNumber = false) {
	const params = modUtils.getUrlParamsToObject();
	const ctParam = params.CT && params.CT.toLowerCase();
	if (ctParam === 'yes' || ignoreCTParamToShowNumber) {
		modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber = true;
	}
};
